import {NgModule, Optional, SkipSelf, APP_INITIALIZER} from '@angular/core';
import {HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {DatePipe} from '@angular/common';

import {environment} from '@env/environment';
import {AuthGuard} from './guards/auth.guard';
import {NoAuthGuard} from './guards/no-auth.guard';

import {WindowRefService} from './window-ref.service';
import {SiteInfosService} from './services/site-infos.service';

import {NgxSpinnerModule} from 'ngx-spinner';

import {TokenInterceptor} from './interceptors/token.interceptor';

import {throwIfAlreadyLoaded} from './guards/module-import.guard';

// import ngx-translate and the http loader
import {TranslateLoader, TranslateParser, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader, WikTranslateParser} from './translator';

import {StoreModule} from '@ngrx/store';
import {reducer} from '@app/state/ota/app.reducer-ota';
import {reducerVoucher} from '@app/state/voucher/app.reducer-voucher';
import {reducerGenaral} from '@app/state/general/app.reducer';
//import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {GtmService} from '@app/core/services/gtm.service'
import {Logger} from './logger.service';
const log = new Logger('core module');

export function initializeApp(siteInfos: SiteInfosService, winRef: WindowRefService, gtm: GtmService) {
    log.warn('run initializeApp');
    return (): Promise<any> => {
        let promise = siteInfos.load(winRef.appConfigSite.idEtab);
        promise.then(response => {
            winRef.appConfigSite.idEtab = siteInfos.getEtabData()['etablissementId'];
            siteInfos.getEtabData()["isprod"] ? gtm.postponeInitialization(siteInfos.getEtabData()['sGtagManager']) : null;
        });
        return promise;
    }
}

export function HttpLoaderFactory(http: HttpClient, winRef: WindowRefService) {
    return new TranslateHttpLoader(http, winRef);
}


// import {SocialLoginModule, AuthServiceConfig} from "angularx-social-login";
// import {GoogleLoginProvider, FacebookLoginProvider} from "angularx-social-login";
// import {config as appConfig} from 'app/core/app-config'
// let config = new AuthServiceConfig([
//     {
//         id: GoogleLoginProvider.PROVIDER_ID,
//         provider: new GoogleLoginProvider(appConfig.GoogleOAuthClientId)
//     },
//     {
//         id: FacebookLoginProvider.PROVIDER_ID,
//         provider: new FacebookLoginProvider(appConfig.FacebookAppId, {
//             scope: 'user_address,email,user_mobile_phone',
//         })
//     }
// ]);

// export function provideConfig() {
//     return config;
// }


@NgModule({
    imports: [
        HttpClientModule,
        NgxSpinnerModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient, WindowRefService]
            },
            parser: {provide: TranslateParser, useClass: WikTranslateParser},
        }),
        // SocialLoginModule,
        StoreModule.forRoot({
            appState: reducer,
            appStateVoucher: reducerVoucher,
            appStateGenaral: reducerGenaral,
        }),
//        StoreDevtoolsModule.instrument({
//            name: "OTA devtools",
//            maxAge: 15, // Retains last 15 states
//            //logOnly: environment.production, // Restrict extension to log-only mode
//        }),
    ],
    providers: [
        AuthGuard,
        NoAuthGuard,
        WindowRefService,

        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },

        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [SiteInfosService, WindowRefService,GtmService],
            multi: true
        },
        DatePipe,
        // {
        //     provide: AuthServiceConfig,
        //     useFactory: provideConfig
        // },

    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
